import React, { useEffect, useState, useCallback } from 'react';
import { Box, Paper, Toolbar, Typography, Grid, TextField, Button, Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Chip } from '@mui/material';
import { Add as AddIcon, Refresh as RefreshIcon } from '@mui/icons-material';
import api from '../api';
import { toast } from 'react-toastify';

export default function TemplateWorkOrders() {
  const [form, setForm] = useState({
    title: '', priority: 'Medium', description: '', assignedUserId: '', dueDate: '', location: '', equipment: '', companyId: ''
  });
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    try { setLoading(true); const data = await api.workOrders.template.list(); setList(data || []); }
    catch(e){ console.error(e); toast.error('Şablonlar yüklenemedi'); }
    finally{ setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleCreate = async () => {
    try {
      if (!form.title.trim()) { toast.error('Başlık gerekli'); return; }
      const payload = {
        Title: form.title,
        Description: form.description,
        Priority: form.priority,
        AssignedUserId: form.assignedUserId,
        DueDate: form.dueDate || null,
        Location: form.location,
        Equipment: form.equipment,
        CreatedByUserId: null,
        CompanyId: form.companyId ? parseInt(form.companyId) : null
      };
      await api.workOrders.template.create(payload);
      toast.success('Şablon oluşturuldu');
      setForm({ title: '', priority: 'Medium', description: '', assignedUserId: '', dueDate: '', location: '', equipment: '', companyId: '' });
      load();
    } catch(e){ console.error(e); toast.error('Oluşturma başarısız'); }
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Paper elevation={1}>
        <Toolbar variant="dense" sx={{ gap: 2 }}>
          <Typography variant="h6" sx={{ flex: 1 }}>Şablon İş Emirleri</Typography>
          <Button startIcon={<RefreshIcon />} onClick={load} disabled={loading}>Yenile</Button>
        </Toolbar>
      </Paper>

      <Box sx={{ p: 2 }}>
        <Paper sx={{ p: 2, mb: 2 }}>
          <Typography variant="subtitle1" gutterBottom>Yeni Şablon</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}><TextField label="Başlık" value={form.title} onChange={e=>setForm(f=>({...f,title:e.target.value}))} fullWidth required /></Grid>
            <Grid item xs={12} md={4}><TextField label="Öncelik" value={form.priority} onChange={e=>setForm(f=>({...f,priority:e.target.value}))} fullWidth /></Grid>
            <Grid item xs={12} md={4}><TextField type="date" label="Termin" InputLabelProps={{shrink:true}} value={form.dueDate} onChange={e=>setForm(f=>({...f,dueDate:e.target.value}))} fullWidth /></Grid>
            <Grid item xs={12}><TextField label="Açıklama" value={form.description} onChange={e=>setForm(f=>({...f,description:e.target.value}))} fullWidth multiline rows={3} /></Grid>
            <Grid item xs={12} md={4}><TextField label="Atanan Kullanıcı" value={form.assignedUserId} onChange={e=>setForm(f=>({...f,assignedUserId:e.target.value}))} fullWidth /></Grid>
            <Grid item xs={12} md={4}><TextField label="Lokasyon" value={form.location} onChange={e=>setForm(f=>({...f,location:e.target.value}))} fullWidth /></Grid>
            <Grid item xs={12} md={4}><TextField label="Ekipman" value={form.equipment} onChange={e=>setForm(f=>({...f,equipment:e.target.value}))} fullWidth /></Grid>
            <Grid item xs={12} md={3}><TextField label="CompanyID" value={form.companyId} onChange={e=>setForm(f=>({...f,companyId:e.target.value}))} fullWidth /></Grid>
            <Grid item xs={12} md={3}><Button variant="contained" startIcon={<AddIcon />} onClick={handleCreate}>Oluştur</Button></Grid>
          </Grid>
        </Paper>

        <Paper>
          <TableContainer>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Başlık</TableCell>
                  <TableCell>Öncelik</TableCell>
                  <TableCell>Tip</TableCell>
                  <TableCell>Statü</TableCell>
                  <TableCell>Oluşturma</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((t) => (
                  <TableRow key={t.workOrderID}>
                    <TableCell>{t.workOrderID}</TableCell>
                    <TableCell>{t.title}</TableCell>
                    <TableCell>{t.priority}</TableCell>
                    <TableCell><Chip label={t.workOrderType} size="small" /></TableCell>
                    <TableCell>{t.workOrderStatus}</TableCell>
                    <TableCell>{t.creationDate}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
    </Box>
  );
}

